import type { AiSalesUiEventName } from '../types/events';

export function trackAiSalesEvent(name: AiSalesUiEventName, payload: Record<string, unknown> = {}): void {
  window.dispatchEvent(new CustomEvent('ai-sales:event', { detail: { name, at: new Date().toISOString(), payload } }));
}
